import React from 'react';
import { Edit, Trash2 } from 'lucide-react';

const CompanySaleCard = ({ sale, onEditPrice, onRemove }) => {
  const salePrice = parseFloat(sale.price) || 0;
  const displayCardId = sale.sample_card_id ?? sale.card_id ?? sale.card?.id;

  return (
    <div className="bg-gray-800 rounded-lg p-6 border border-green-500/50 hover:border-green-500 transition-all relative">
      {/* Badge with available count */}
      {sale.availableCount !== undefined && sale.availableCount > 1 && (
        <div className="absolute top-2 right-2 z-10 bg-green-600 text-white rounded-full w-10 h-10 flex items-center justify-center font-bold text-sm shadow-lg border-2 border-white/50">
          {sale.availableCount}
        </div>
      )}
      <div className="flex items-center justify-between mb-4">
        <span className="px-3 py-1 rounded-full text-xs font-semibold bg-green-600/30 text-green-300 border border-green-500/50">
          💰 Buy Now
        </span>
      </div>
      
      <h3 className="text-xl font-bold text-white mb-3">
        {sale.player?.full_name || `Card #${sale.card_id}`}
      </h3>
      
      <div className="space-y-2 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Position:</span>
          <span className="text-white font-semibold">{sale.player?.position || 'N/A'}</span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Rarity:</span>
          <span className="text-white font-semibold">
            ⭐ {sale.rarity?.display_name || sale.rarity?.name || 'N/A'}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">Card ID:</span>
          <span className="text-gray-300 font-mono text-xs">#{displayCardId ?? 'N/A'}</span>
        </div>
        <div className="border-t border-gray-700 pt-2 mt-2">
          <div className="flex items-center justify-between">
            <span className="text-gray-400 text-sm">Price:</span>
            <span className="text-green-400 font-bold text-xl">{salePrice.toFixed(2)} DIOS</span>
          </div>
        </div>
      </div>
      
      <div className="flex space-x-2 mt-4 pt-4 border-t border-gray-700">
        <button
          onClick={() => onEditPrice(sale)}
          className="flex-1 px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-lg transition-all flex items-center justify-center"
        >
          <Edit className="w-4 h-4 mr-1" />
          Edit Price
        </button>
        <button
          onClick={() => onRemove(sale.id)}
          className="px-3 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-lg transition-all flex items-center justify-center"
        >
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default CompanySaleCard;
